import React from 'react';

const features = [
  { category: 'Inbox', label: 'Temporary addresses', free: '1 at a time', pro: '3 simultaneous', business: 'Unlimited' },
  { category: 'Inbox', label: 'Address expiry', free: '24 hours', pro: 'Never', business: 'Never' },
  { category: 'Inbox', label: 'Custom username', free: false, pro: true, business: true },
  { category: 'Inbox', label: 'Custom domain (your own)', free: false, pro: false, business: true },
  { category: 'Inbox', label: 'Priority delivery', free: false, pro: true, business: true },
  { category: 'Storage', label: 'Cloud drive', free: '1 GB', pro: '25 GB', business: '200 GB shared' },
  { category: 'Storage', label: 'Attachment downloads', free: true, pro: true, business: true },
  { category: 'Storage', label: 'Drive file manager', free: false, pro: true, business: true },
  { category: 'Search', label: 'Message search', free: 'Basic (7 days)', pro: 'Full-text (1 year)', business: 'Full-text (unlimited)' },
  { category: 'Search', label: 'Attachment search', free: false, pro: false, business: true },
  { category: 'API', label: 'REST API access', free: false, pro: 'Read-only', business: 'Full access' },
  { category: 'API', label: 'Webhook support', free: false, pro: false, business: true },
  { category: 'Team', label: 'Team seats', free: '1', pro: '1', business: 'Up to 10' },
  { category: 'Team', label: 'Shared inbox', free: false, pro: false, business: true },
  { category: 'Support', label: 'Support channel', free: 'Community', pro: 'Email (48h)', business: 'Priority email (4h)' },
  { category: 'Support', label: 'Uptime SLA', free: false, pro: false, business: '99.9%' },
];

const categories = [...new Set(features.map((f) => f.category))];

function CellValue({ value }: { value: string | boolean }) {
  if (value === true) {
    return (
      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-accent/10 border border-accent/30">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M2 5L4 7L8 3" stroke="#4FFFB0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-muted border border-border">
        <svg width="8" height="8" viewBox="0 0 10 10" fill="none">
          <path d="M3 3L7 7M7 3L3 7" stroke="#6B6B85" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
    );
  }
  return <span className="text-sm text-foreground font-medium">{value}</span>;
}

export default function FeatureTable() {
  return (
    <div className="rounded-2xl border border-border overflow-hidden">
      {/* Table header */}
      <div className="grid grid-cols-4 bg-muted border-b border-border">
        <div className="px-5 py-4">
          <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Feature</span>
        </div>
        {['Free', 'Pro', 'Business'].map((plan) => (
          <div key={`th-${plan}`} className="px-5 py-4 text-center">
            <span className={`text-sm font-bold ${plan === 'Pro' ? 'text-primary' : 'text-foreground'}`}>
              {plan}
            </span>
          </div>
        ))}
      </div>

      {/* Rows grouped by category */}
      {categories.map((cat) => (
        <React.Fragment key={`cat-${cat}`}>
          <div className="grid grid-cols-4 bg-secondary/30 border-b border-border">
            <div className="px-5 py-2 col-span-4">
              <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">{cat}</span>
            </div>
          </div>
          {features
            .filter((f) => f.category === cat)
            .map((f) => (
              <div
                key={`feat-row-${f.label}`}
                className="grid grid-cols-4 border-b border-border/50 hover:bg-muted/30 transition-colors duration-100"
              >
                <div className="px-5 py-3.5 flex items-center">
                  <span className="text-sm text-secondary-foreground">{f.label}</span>
                </div>
                {[f.free, f.pro, f.business].map((val, i) => (
                  <div key={`feat-cell-${f.label}-${i}`} className="px-5 py-3.5 flex items-center justify-center">
                    <CellValue value={val} />
                  </div>
                ))}
              </div>
            ))}
        </React.Fragment>
      ))}
    </div>
  );
}